import { Divider } from 'antd';
import React from 'react';

const SectionDivider = () => {
  return (
    <Divider className="border-content-secondary">
      <span className="text-content-secondary font-size-base font-weight-normal">OR</span>
    </Divider>
  );
};

export default SectionDivider;
